var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZoom = function SvgZoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5c.6 0 1 .4 1 1v1h1c.6 0 1 .4 1 1s-.4 1-1 1H9v1c0 .6-.4 1-1 1s-1-.4-1-1V9H6c-.6 0-1-.4-1-1s.4-1 1-1h1V6c0-.6.4-1 1-1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8 1c3.9 0 7 3.1 7 7 0 1.4-.4 2.7-1.1 3.8l5.2 5.2c.6.6.6 1.5 0 2.1-.6.6-1.5.6-2.1 0l-5.2-5.2C10.7 14.6 9.4 15 8 15c-3.9 0-7-3.1-7-7s3.1-7 7-7zm0 3c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgZoom;